import "bootstrap-colorpicker"

export default function attachColorPicker(context) {
    const $context = $(context);

    $context.find('.colorpicker-input').colorpicker({
        autoInputFallback: false,
        format: 'hex',
    });
}
